<template>
    <div :class="['page', { 'page--embed': partnerAppEmbedCustomization }]">
        <div class="row gradient-background">
            <div class="wrapper wrapper--no-max-width">
                <header :class="['row__header', { 'row__header--partner-app': isPartnerApp }]">
                    <back-button
                        :isAbsolute="false"
                        :isBlack="true"
                        :isHiddenOnDesktop="true"
                    />
                    <h1>{{ $t('profile.support') }}</h1>
                </header>
                <section v-for="section in sections"
                    :key="section.title"
                    class="section"
                >
                    <h2 class="section__title">{{ $t(section.title) }}</h2>
                    <div class="section__content">
                        <div class="section__content--links">
                            <template v-for="(item, index) in section.elements">
                                <a v-if="item.isExternal"
                                    :key="index"
                                    class="section__content--links-link"
                                    :href="item.link"
                                    target="_blank"
                                >
                                    {{ $t(item.text) }}
                                </a>
                                <router-link v-else
                                    :key="index"
                                    :to="item.link"
                                    class="section__content--links-link"
                                >
                                    {{ $t(item.text) }}
                                </router-link>
                            </template>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Shared Modules
import {
    FaqQuickLink,
} from '@shared/modules/customer-first/constants/faq';
import {
    getLocatedFaqUrl,
} from '@shared/modules/customer-first/helpers/faq';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';

export default {
    name: 'support',
    components: {
        backButton,
    },
    data() {
        return {
            sections: [],
        };
    },
    computed: {
        ...mapGetters([
            'isUsaRegulation',
            'isPartnerApp',
            'locale',
            'partnerAppEmbedCustomization',
        ]),
    },
    created() {
        this.initSections();
    },
    methods: {
        /**
         * Inits the support sections
         *
         * @returns {void}
         */
        initSections() {
            const sections = [
                {
                    title: 'profile.help',
                    elements: [
                        {
                            text: 'more.faqs',
                            link: getLocatedFaqUrl({
                                locale: this.locale,
                                isUsaRegulation: this.isUsaRegulation,
                            }),
                            isExternal: true,
                        },
                    ],
                },
                {
                    title: 'profile.support',
                    elements: [
                        {
                            text: 'profile.contactUsHere',
                            link: 'https://mobile-app-content.socios.com/en_gb/contact-us/',
                            isExternal: true,
                        },
                    ],
                },
            ];

            if (!this.isUsaRegulation) {
                const faqQuickLinkSection = {
                    title: 'profile.quickLinks.title',
                    elements: this.getFaqQuickExternalLinks(),
                };

                sections.splice(1, 0, faqQuickLinkSection);
            }

            this.sections = sections;
        },

        /**
         * Return external faq quick links
         *
         * @returns {Array} external faq quick links
         */
        getFaqQuickExternalLinks() {
            const faqQuickLinks = [];

            // eslint-disable-next-line guard-for-in
            for (const link in FaqQuickLink) {
                faqQuickLinks.push({
                    text: `profile.quickLinks.${FaqQuickLink[link]}`,
                    link: getLocatedFaqUrl({
                        locale: this.locale,
                        subpath: FaqQuickLink[link],
                    }),
                    isExternal: true,
                });
            }

            return faqQuickLinks;
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    color: $cyprus-color;

    .section {
        padding: 2rem;
        max-width: 60%;

        @include max-width(md) {
            max-width: 100%;
        }

        &__title {
            font-weight: bold;
            font-size: 2rem;
            line-height: 3rem;
            color: $daintree-color;
            margin: 1rem 0;
        }

        &__content {
            &--links {
                background-color: $white-color;
                border-radius: 1rem;
                display: grid;
                grid-auto-flow: row;

                &-link {
                    text-decoration: none;
                    color: $cyprus-color;
                    font-family: "Nunito";
                    padding: 3.5rem;
                    font-size: 1.8rem;
                    line-height: 2.5rem;

                    &:not(:last-of-type) {
                        border-bottom: solid 1px $mercury-color;
                    }

                    &:hover {
                        color: $black-color;
                    }
                }
            }
        }
    }
}
</style>